import { render, staticRenderFns } from "./M-header.vue?vue&type=template&id=8fe9bfca&scoped=true"
import script from "./M-header.vue?vue&type=script&lang=js"
export * from "./M-header.vue?vue&type=script&lang=js"
import style0 from "./M-header.vue?vue&type=style&index=0&id=8fe9bfca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe9bfca",
  null
  
)

export default component.exports